import { c as _c } from "react/compiler-runtime";
import { DiscountTag } from "@local/offer/src/modules/store/ProductPage/discountTag";
import { cn } from "@local/utils/src/cn";
import { Money } from "../../ui/Money";
interface DiscountPriceProps {
  price: {
    value: number;
    discountValue: number | null;
  };
  className?: string;
  market?: string;
  onDark?: boolean;
}
const getDiscountInfo = (price: {
  value: number;
  discountValue: number | null;
}) => {
  const hasDiscount = typeof price.discountValue === "number" && price.value > 0 && price.discountValue >= 0 && price.discountValue < price.value;
  const discountPercentage = hasDiscount ? Math.round((price.value - price.discountValue!) / price.value * 100) : 0;
  return {
    hasDiscount,
    discountPercentage
  };
};
export const DiscountPrice = t0 => {
  const $ = _c(10);
  const {
    price,
    className,
    market,
    onDark
  } = t0;
  let t1;
  if ($[0] !== price) {
    t1 = getDiscountInfo(price);
    $[0] = price;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    hasDiscount,
    discountPercentage
  } = t1;
  let t2;
  if ($[2] !== className || $[3] !== discountPercentage || $[4] !== hasDiscount || $[5] !== market || $[6] !== onDark || $[7] !== price.discountValue || $[8] !== price.value) {
    t2 = hasDiscount ? <div className={cn("flex flex-wrap items-center gap-2 font-bold", className)}><span className="flex items-baseline gap-2"><span className={cn("text-sm font-normal line-through", onDark ? "text-gray-300" : "text-gray-600")}><Money value={price.value} market={market} srLabel="Original price" /></span><span className="text-lg"><Money value={price.discountValue} market={market} srLabel="Sale price" /></span></span><DiscountTag discount={discountPercentage} market={market} /></div> : <div className={cn("flex items-center gap-2 font-bold", className)}><span><Money value={price.value} market={market} /></span></div>;
    $[2] = className;
    $[3] = discountPercentage;
    $[4] = hasDiscount;
    $[5] = market;
    $[6] = onDark;
    $[7] = price.discountValue;
    $[8] = price.value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};